"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allUtmParameterKeys = void 0;
var utmParameterKeys = {
    utm_source: 'utm_source',
    utm_medium: 'utm_medium',
    utm_campaign: 'utm_campaign',
    utm_term: 'utm_term',
    utm_content: 'utm_content',
    utm_id: 'utm_id',
};
exports.allUtmParameterKeys = Object.keys(utmParameterKeys);
